<script setup lang="ts">
/**
 * Orbit rings — satellites circling on faint concentric orbits around a
 * central glow. Ring sizes in % of the shorter hero edge.
 */
const rings = [
  { size: '38%', dur: '26s' },
  { size: '58%', dur: '38s' },
  { size: '80%', dur: '52s' }
]
</script>

<template>
  <div
    class="site-hero-anim"
    aria-hidden="true"
  >
    <div
      class="absolute left-1/2 top-1/2 h-1/3 w-1/3 -translate-x-1/2 -translate-y-1/2 rounded-full opacity-25"
      style="background: var(--site-accent); filter: blur(90px)"
    />
    <div
      v-for="ring in rings"
      :key="ring.size"
      class="site-anim-orbit-ring left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 aspect-square"
      :style="{ width: ring.size }"
    >
      <div
        class="site-anim-orbit-carrier"
        :style="{ '--dur': ring.dur }"
      >
        <span class="site-anim-orbit-dot" />
      </div>
    </div>
  </div>
</template>
